import * as React from 'react';
import { Progress as ProgressPrimitive } from 'radix-ui';

import { cn } from '@/lib/utils';

function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        'relative h-4 w-full overflow-hidden rounded-full bg-neutrals-200 dark:bg-neutrals-800',
        className,
      )}
      {...props}>
      <ProgressPrimitive.Indicator
        className="size-full flex-1 bg-primary-blue-600 transition-all dark:bg-neutrals-200"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
